export class PaymentSource {
  public PaymentSource: string;
  public Descr: string;
}
